<div class="booking-page" *ngIf="service">
  <div class="booking-card">

    <!-- HEADER -->
    <div class="booking-header">
      <span class="material-symbols-outlined back-icon" (click)="goBack()">arrow_back</span>
      <div>
        <h2>Request Booking</h2>
        <p class="subtitle">Fill in your details — the vendor will confirm your booking</p>
      </div>
    </div>

    <!-- SERVICE SUMMARY -->
    <div class="service-summary">
      <img *ngIf="service.media_type==='image'" [src]="imageUrl + service.media_url" alt="service image">
      <div class="summary-placeholder" *ngIf="service.media_type!=='image'">
        <span class="material-symbols-outlined">photo_camera</span>
      </div>
      <div class="summary-info">
        <h3>{{ service.service_name }}</h3>
        <span class="category-tag">{{ service.category?.name || service.category }}</span>
        <div class="summary-meta">
          <div class="meta-item">
            <span class="material-symbols-outlined">payments</span>
            <span>₹{{ service.price | number }}</span>
          </div>
          <div class="meta-item">
            <span class="material-symbols-outlined">schedule</span>
            <span>{{ service.duration }}</span>
          </div>
          <div class="meta-item">
            <span class="material-symbols-outlined">calendar_month</span>
            <span>{{ formattedDate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- NOTICE BANNER -->
    <div class="notice-banner">
      <span class="material-symbols-outlined">info</span>
      <span>Payment is settled directly with the vendor after confirmation. No online payment required.</span>
    </div>

    <!-- FORM -->
    <form [formGroup]="bookingForm">

      <div class="form-section-title">Your Details</div>

      <div class="form-row two-col">
        <div class="form-group">
          <label>Full Name <span class="req">*</span></label>
          <input type="text" formControlName="customer_name" placeholder="Your full name">
          <div class="error" *ngIf="bookingForm.get('customer_name')?.touched && bookingForm.get('customer_name')?.invalid">
            Name is required
          </div>
        </div>
        <div class="form-group">
          <label>Phone Number <span class="req">*</span></label>
          <input type="tel" formControlName="customer_phone" placeholder="10-digit mobile number">
          <div class="error" *ngIf="bookingForm.get('customer_phone')?.touched && bookingForm.get('customer_phone')?.invalid">
            Valid 10-digit phone required
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>Email <span class="req">*</span></label>
        <input type="email" formControlName="customer_email" placeholder="your@email.com">
        <div class="error" *ngIf="bookingForm.get('customer_email')?.touched && bookingForm.get('customer_email')?.invalid">
          Valid email is required
        </div>
      </div>

      <div class="form-section-title" style="margin-top:20px">Event Details</div>

      <div class="form-row two-col">
        <div class="form-group">
          <label>Function / Event Name <span class="req">*</span></label>
          <input type="text" formControlName="function_name" placeholder="e.g. Wedding, Reception, Engagement">
          <div class="error" *ngIf="bookingForm.get('function_name')?.touched && bookingForm.get('function_name')?.invalid">
            Function name is required
          </div>
        </div>
        <div class="form-group">
          <label>Location <span class="req">*</span></label>
          <select formControlName="location">
            <option value="">Select location</option>
            <option *ngFor="let loc of service?.service_locations" [value]="loc">{{ loc }}</option>
          </select>
          <div class="error" *ngIf="bookingForm.get('location')?.touched && bookingForm.get('location')?.invalid">
            Location is required
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>Special Requirements <span class="optional">(Optional)</span></label>
        <textarea formControlName="additional_details" placeholder="Any special requests, requirements, or details you want the vendor to know..."></textarea>
      </div>

      <button type="button" class="submit-btn" (click)="submitBooking()" [disabled]="submitting">
        <span class="material-symbols-outlined spin-icon" *ngIf="submitting">autorenew</span>
        <span class="material-symbols-outlined" *ngIf="!submitting">send</span>
        {{ submitting ? 'Sending Request...' : 'Send Booking Request' }}
      </button>

    </form>
  </div>
</div>

<!-- Loading state when service not yet loaded -->
<div class="booking-page loading-state" *ngIf="!service">
  <div class="booking-card">
    <div class="skeleton-header"></div>
    <div class="skeleton-summary"></div>
    <div class="skeleton-form"></div>
  </div>
</div>